// Nils 03/11 : montant des factures et avoirs écrit en lettres (orthographe traditionnelle :
// « vingt et un », « soixante et onze », « quatre-vingts », « deux cents », « mille » invariable).
const UNITES = ["zéro", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf", "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"];
const DIZAINES = ["", "", "vingt", "trente", "quarante", "cinquante", "soixante"];

// 0 à 99 ; finale : le nombre termine l'expression (accord de « quatre-vingts »).
function moinsDeCent(n, finale) {
  if (n < 20) return UNITES[n];
  const d = Math.floor(n / 10), u = n % 10;
  if (d <= 6) return u === 0 ? DIZAINES[d] : u === 1 ? `${DIZAINES[d]} et un` : `${DIZAINES[d]}-${UNITES[u]}`;
  if (d === 7) return u === 1 ? "soixante et onze" : `soixante-${UNITES[10 + u]}`;
  if (d === 8) return u === 0 ? (finale ? "quatre-vingts" : "quatre-vingt") : `quatre-vingt-${UNITES[u]}`;
  return `quatre-vingt-${UNITES[10 + u]}`;
}
// 0 à 999 (0 → "").
function moinsDeMille(n, finale) {
  const c = Math.floor(n / 100), r = n % 100;
  let s = "";
  if (c === 1) s = "cent";
  else if (c > 1) s = `${UNITES[c]} cent${r === 0 && finale ? "s" : ""}`;
  if (r) s = `${s ? s + " " : ""}${moinsDeCent(r, finale)}`;
  return s;
}
export function nombreEnLettres(n) {
  n = Math.floor(Math.abs(Number(n) || 0));
  if (n === 0) return "zéro";
  const parts = [];
  const milliards = Math.floor(n / 1e9), millions = Math.floor((n % 1e9) / 1e6), milliers = Math.floor((n % 1e6) / 1000), reste = n % 1000;
  if (milliards) parts.push(`${moinsDeMille(milliards, true)} milliard${milliards > 1 ? "s" : ""}`);
  if (millions) parts.push(`${moinsDeMille(millions, true)} million${millions > 1 ? "s" : ""}`);
  if (milliers) parts.push(milliers === 1 ? "mille" : `${moinsDeMille(milliers, false)} mille`);
  if (reste) parts.push(moinsDeMille(reste, true));
  return parts.join(" ");
}
// 51891.84 → « cinquante et un mille huit cent quatre-vingt-onze dirhams et quatre-vingt-quatre centimes ».
export function montantEnLettres(montant) {
  const centimesTotal = Math.round(Math.abs(Number(montant) || 0) * 100);
  const dh = Math.floor(centimesTotal / 100), cts = centimesTotal % 100;
  // « un million de dirhams », « deux millions de dirhams ».
  const de = dh > 0 && dh % 1e6 === 0 ? " de" : "";
  let s = `${nombreEnLettres(dh)}${de} dirham${dh > 1 ? "s" : ""}`;
  if (cts) s += ` et ${nombreEnLettres(cts)} centime${cts > 1 ? "s" : ""}`;
  return s;
}
// Phrase imprimée sous les totaux d'une facture ou d'un avoir.
export function phraseArretee({ montant, avoir = false, exonere = false }) {
  const debut = avoir ? "Arrêté le présent avoir à la somme de" : "Arrêtée la présente facture à la somme de";
  return `${debut} : ${montantEnLettres(montant)}${exonere ? (avoir ? ", exonéré de TVA" : ", exonérée de TVA") : " TTC"}.`;
}
